export default function pluralize(word, amount = 0) {
	if (!word) return word
	return (amount > 1 || amount === 0) ? `${word}s` : word

}
